import classnames from 'classnames/bind';
import Typography from 'components/Typography';
import T from 'prop-types';
import React from 'react';

import styles from './StepIndicator.module.scss';

const cx = classnames.bind(styles);

const StepIndicator = ({ steps = 3, current }) => (
  <div className={cx('wrapper')}>
    {Array(steps)
      .fill(null)
      .map((_, idx) => (
        <div key={`step-${idx}`} className={cx('indicator', { active: idx + 1 === current })}>
          <Typography className={cx('indicator--number')}>{idx + 1}</Typography>
        </div>
      ))}
  </div>
);

StepIndicator.propTypes = {
  steps: T.number,
  current: T.number.isRequired,
};

export default StepIndicator;
